import iconFitness from "../images/iconFitness.png";
export default function DisplayTraining({ name, icon, description, last }) {
  return (
    <div className="px-10 py-6 relative">
      <div className="flex flex-row justify-between items-center  mb-4">
        <h4 className="font-semibold text-2xl">{name}</h4>
        <img src={icon} alt={name} />
      </div>
      <p className="text-light-grey font-medium leading-5">{description}</p>
      {/* {!last && (
        <div className="w-40 h-[2px] md:h-36 md:w-[2px] bg-[#D2D0CF] absolute  -bottom-4 left-16 lg:top-10 lg:right-0 "></div>
      )} */}
    </div>
  );
}
